export const SCHEDULED = 'SCHEDULED';
export const NOT_SCHEDULED = 'NOT_SCHEDULED';
export const NOT_TRANSCRIBED_LIMIT_REACHED = 'NOT_TRANSCRIBED_LIMIT_REACHED';
export const NOT_TRANSCRIBED_NO_SEAT = 'NOT_TRANSCRIBED_NO_SEAT';
export const NOT_TRANSCRIBED_INACCESSIBLE_RECORDING = 'NOT_TRANSCRIBED_INACCESSIBLE_RECORDING';
export const INVALID_RECORDING_FORMAT = 'INVALID_RECORDING_FORMAT';
export const STARTED = 'STARTED';
export const COMPLETED = 'COMPLETED';
export const ERROR = 'ERROR';
export const DELETED = 'DELETED';